<template>
    <div id="wrapper" class="wrapper">
        <router-view></router-view>
        <!-- 音乐组件 -->
        <report-audio></report-audio>
        <!-- 代金券弹框 -->
		<van-popup v-bind:value="userShowDiscountPop" class="discount-pop">
            <div class="discount-button-box">
                <button class="discount-button" @click.stop="clickGetDicount">朕收下了</button>
            </div>
        </van-popup>
        <!-- 免费弹框 -->
        <van-popup v-bind:value="userShowFreePop" class="free-pop" :class="'free-pop-'+freeType">
            <div class="free-button-box">
                <button class="free-button" @click.stop="clickGetFree">{{freeType == 1 ? '朕收下了' : '马上使用'}}</button>
            </div>
        </van-popup>
    </div>
</template>
<script>
    import { WEIXIN } from './modules/weixin';
    import { UTILS } from './modules/utils';
    import { API } from './modules/api';
	import ReportAudio from './components/report/ReportAudio.vue'
    export default {
        name: "App",
        components: { ReportAudio },
        computed: {
            userShowDiscountPop() {
                return this.$store.state.user.userShowDiscountPop;
            },
            userShowFreePop() {
                return this.$store.state.user.userShowFreePop;
            },
            reportFPayData() {
                return this.$store.state.user.reportFPayData;
            },
            reportSPayData() {
                return this.$store.state.user.reportSPayData;
            }
        },
        data() {
            return {
                freeType: 1
            }
        },
        mounted() {
            this.gotoPage();
        },
        methods: {
            gotoPage() {
                var curPath = this.$router.history.current.path;
                if(curPath == '/') {
                    setTimeout(() => {
                        this.$router.replace('/home');
                    }, 20);
                }
            }
        }
    };
</script>
